export enum DateTimeFormat {
  DATE_TIME = 'DD/MM/YYYY HH:mm',
  DATE = 'DD/MM/YYYY',
  TIME = 'HH:mm',
}
